import React from 'react';
import type { CorrectionContext } from '../hooks/useCorrectionContext';
import type { CorrectionScenarioId } from '../scenarios/correctionScenarioTypes';
import { CorrectionActionSelector } from './CorrectionActionSelector';

type Props = {
  ctx: CorrectionContext;
  selectedScenarioId: CorrectionScenarioId | null;
  onSelectScenario: (id: CorrectionScenarioId) => void;
};

export function CorrectionWorkspaceHeader({ ctx, selectedScenarioId, onSelectScenario }: Props) {
  return (
    <div className="correction-workspace-header">
      <h3 className="correction-workspace-header__title">Корректировка маршрута</h3>
      <CorrectionActionSelector
        ctx={ctx}
        selectedScenarioId={selectedScenarioId}
        onSelectScenario={onSelectScenario}
      />
    </div>
  );
}
